import { Grid, Stack, styled, Typography, useTheme } from "@mui/material";
import PrimaryButton from "components/button/PrimaryButton";
import SecondaryButton from "components/button/SecondaryButton";
import FlexBetween from "components/flexbox/FlexBetween";
import FlexBox from "components/flexbox/FlexBox";
import GradientText from "components/GradientText";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const AirdropSection = () => {
  const innerHeight = window.innerHeight;
  const theme = useTheme()
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  return (
    <Section
      id="airdrop-section"
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        height={"100%"}
        spacing={{ xs: 3, md: 10 }}
        px={{ xs: 0, sm: 10 }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid container justifyItems={"center"} rowSpacing={{ xs: 7, md: 0 }} px={{ lg: 10 }}>
          <Grid item xs={12} md={6} p={{ xs: 0, md: 5 }}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.3 }}
            >
              <Stack flex={1} gap={{ xs: '24px', md: '48px' }} display="grid">
                <GradientText
                  text="Deposit to Trading Fund Earn Yield + Flaex Points"
                  background="linear-gradient(25deg,#FA00FF,#B580FF 25%,#FFFFFF 35%,#FFFFFF 80%)"
                  fontSize={{
                    xs: 17,
                    xmd: 25,
                    xlg: 38,
                  }}
                  fontWeight={600}
                  textAlign={{ xs: "center", xmd: "left" }}
                  padding={{ xs: "0px 1rem", sm: "unset" }}
                />
                <Stack
                  border="1px solid #4C4663"
                  padding={{ xs: "15px", xlg: "16px 24px" }}
                  borderRadius="9px"
                  width={{ xs: "100%", sm: "auto" }}
                  margin={{ xs: "0px auto", sm: "unset" }}
                >
                  <FlexBetween>
                    <FlexBox alignItems="center" gap="12px" sx={{
                      '& img': {
                        width: 48, height: 48
                      },
                      [theme.breakpoints.down('lg')]: {
                        '& img': {
                          width: 28, height: 28
                        }
                      }
                    }}>
                      <img
                        src="/static/coins/USDC.svg"
                        alt="usdc"
                      />
                      <Typography fontSize={{ xs: '1rem', md: '1.3rem' }} sx={{ fontWeight: 600 }}>
                        USDC
                      </Typography>
                    </FlexBox>
                    <Typography fontSize={{ xs: '1rem', md: '1.3rem' }} fontWeight={600}>
                      6%
                    </Typography>
                  </FlexBetween>
                </Stack>
                <Typography
                  fontSize={{
                    xs: 12,
                    xmd: 18,
                    xlg: 24,
                  }}
                  textAlign={{
                    xs: "center",
                    xmd: "left",
                  }}
                >
                  You will earn more points over time based on the amount you
                  deposit.
                </Typography>
              </Stack>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6} p={{ xs: 0, md: 5 }}>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.5 }}
            >
              <Stack flex={1} gap={{ xs: '24px', md: "45px" }} display="grid" p={0.2}>
                <GradientText
                  text="Deposit to Capital Provider Earn DOUBLE Yield + Points"
                  background="linear-gradient(25deg,#FA00FF,#B580FF 25%,#FFFFFF 35%,#FFFFFF 80%)"
                  fontSize={{ xs: 17, xmd: 25, xlg: 38 }}
                  fontWeight={600}
                  textAlign={"center"}
                />
                <SecondaryButton
                  sx={{
                    borderRadius: "9px",
                    padding: { xs: "9px", xmd: "17px 34px" },
                  }}
                >
                  <FlexBetween width={"100%"}>
                    <FlexBox
                      sx={{
                        gap: { xs: "6px", xmd: "16px" },
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        fontSize={{ xs: '1rem', xdm: '1.3rem' }}
                        color="#BFBCCD"
                        fontWeight={600}
                      >
                        Total Yield
                      </Typography>
                      <FlexBox gap={2} alignItems={"center"} sx={{
                        '& img': {
                          width: 48, height: 48
                        },
                        [theme.breakpoints.down('lg')]: {
                          '& img': {
                            width: 28, height: 28
                          }
                        }
                      }}>
                        <img
                          src="/static/coins/USDC.svg"
                          alt="usdc"
                        />
                        <Typography
                          fontSize={{ xs: '1rem', xdm: '1.15rem', xlg: '1.3rem' }}
                          fontWeight={600}
                        >
                          USDC
                        </Typography>
                      </FlexBox>
                    </FlexBox>
                    <Typography
                      fontSize={{ xs: '1rem', xdm: '1.15rem', xlg: '1.3rem' }}
                      ml={1}
                      fontWeight={600}
                    >
                      12.29%
                    </Typography>
                  </FlexBetween>
                </SecondaryButton>
                <FlexBetween gap={"24px"} width={"100%"}>
                  <FlexBetween
                    sx={{
                      flex: 1,
                      padding: { xs: "12px", xlg: "16px 24px" },
                      border: "1px solid #fff",
                      borderRadius: "9px",
                    }}
                  >
                    <FlexBox gap="12px" alignItems="center" sx={{
                      '& img': {
                        width: 48, height: 48
                      },
                      [theme.breakpoints.down('lg')]: {
                        '& img': {
                          width: 28, height: 28
                        }
                      }
                    }}>
                      <img
                        src="/static/coins/AAVE.svg"
                        alt="aave"
                      />
                      <Typography
                        fontSize={{ xs: 12, xmd: 16, xlg: 20 }}
                        fontWeight={600}
                        color="#BFBCCD"
                      >
                        AAVE
                      </Typography>
                    </FlexBox>
                    <Typography
                      fontSize={{ xs: 12, xmd: 16, xlg: 24 }}
                      fontWeight={600}
                    >
                      6%
                    </Typography>
                  </FlexBetween>
                  <FlexBetween
                    sx={{
                      flex: 1,
                      padding: { xs: "12px", xlg: "16px 24px" },
                      border: "1px solid #fff",
                      borderRadius: "9px",
                    }}
                  >
                    <FlexBox gap="12px" alignItems="center">
                      <Stack
                        sx={{
                          width: { xs: "26px", xmd: "48px" },
                          height: { xs: "26px", xmd: "48px" },
                        }}
                      >
                        <img
                          src="/static/coins/FLAEX.svg"
                          style={{ width: "100%", height: "100%" }}
                          alt="flaex"
                        />
                      </Stack>
                      <Typography
                        fontSize={{ xs: 12, xmd: 16, xlg: 20 }}
                        fontWeight={600}
                        color="#BFBCCD"
                      >
                        FLAEX
                      </Typography>
                    </FlexBox>
                    <Typography
                      fontSize={{ xs: 12, xmd: 16, xlg: 24 }}
                      fontWeight={600}
                    >
                      8.25%
                    </Typography>
                  </FlexBetween>
                </FlexBetween>
              </Stack>
            </motion.div>
          </Grid>
        </Grid>
        <motion.div
          initial={{
            y: 20,
            opacity: 0,
          }}
          animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
          transition={{ duration: 0.2, delay: 0.9 }}
        >
          <PrimaryButton
            onClick={() => window.open('https://app.flaex.io/trading/capital-provider', '_blank')}
            sx={{
              background: "linear-gradient(90deg,#AA3AF6,#FDA9E5)",
              color: "#000",
              fontWeight: 700,
              fontStyle: "italic",
              fontSize: "1.2rem",
              margin: { xs: "auto", xmd: "unset" },
            }}
          >
            Open App
          </PrimaryButton>
        </motion.div>
      </Stack>
    </Section>
  );
};
